<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Biometria | Provedores | Edição" />
    <v-row justify="center" align="center">
      <v-col>
        <form-biometric-provider
          v-if="model"
          v-model="model"
          :readonly="false"
          @submit="submit"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import BiometricProviderService, { BiometricProviderUpdateRequest } from '@/services/BiometricProviderService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRoute, useRouter } from 'vue-router'
import FormBiometricProvider from './form-biometric-provider.vue'
import TPageTitle from '@/components/TPageTitle.vue'

const route = useRoute()
const loader = useLoader()
const router = useRouter()
const snackbar = useSnackBar()

const model = ref<BiometricProviderUpdateRequest>()

async function fetch() {
  try {
    loader.increment()
    const response = await (new BiometricProviderService()).show(route.params.id as string)
    const data = response.data.data

    model.value = {
      name: data.name,
      classpath: data.classpath,
      credentials: data.credentials,
    }
  } catch (error) {
    snackbar.show(
      'Não foi possível buscar o provedor biométrico',
      'error',
    )

    throw error
  } finally {
    loader.decrement()
  }
}

async function submit(model: BiometricProviderUpdateRequest) {
  try {
    loader.increment()

    await (new BiometricProviderService()).update(route.params.id as string, model)

    snackbar.show(
      'Provedor biométrico atualizado com sucesso',
      'success',
    )

    router.push({ name: 'list-biometric-providers' })
  } finally {
    loader.decrement()
  }
}

onMounted(() => fetch())
</script>
